import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import measurementsIcon from '#component/icon/measurements';
import { Card, StyledCardContent, CardHeaderText, CardIdentifiers, LoadingWrapper } from './styles';

function MeasurementCard(props) {
  const {
    identifier,
    index,
    handleOpen,
    presentMeasurements,
    loading
  } = props;

  const iconIdentifier = identifier === 'battery' ? 'Shipment-battery' : identifier;
  const isPresent = presentMeasurements.some(obj => obj.identifier === identifier);
  const { value, unit } = isPresent ?
    presentMeasurements.find(obj => obj.identifier === identifier) : {};
  const icon = measurementsIcon(iconIdentifier);

  return (
    <Card>
      <StyledCardContent
        onClick={() => handleOpen(index)}
      >
        <CardIdentifiers>
          {icon}
          {identifier.toUpperCase()}
        </CardIdentifiers>
        {loading ?
          <LoadingWrapper>
            <CircularProgress size={20} />
          </LoadingWrapper> :
          <CardHeaderText>
            {value}
            {unit}
          </CardHeaderText>}
      </StyledCardContent>
    </Card>
  );
}

export default MeasurementCard;
